export const countries = [
  {
    code: "AD",
    name: "Andorra"
  },
  {
    code: "AE",
    name: "دولة الإمارات العربية المتحدة"
  },
  {
    code: "AF",
    name: "افغانستان"
  },
  {
    code: "AG",
    name: "Antigua and Barbuda"
  },
  {
    code: "AI",
    name: "Anguilla"
  },
  {
    code: "AL",
    name: "Shqipëria"
  },
  {
    code: "AM",
    name: "Հայաստան"
  },
  {
    code: "AO",
    name: "Angola"
  },
  {
    code: "AQ",
    name: "Antarctica"
  },
  {
    code: "AR",
    name: "Argentina"
  },
  {
    code: "AS",
    name: "American Samoa"
  },
  {
    code: "AT",
    name: "Österreich"
  },
  {
    code: "AU",
    name: "Australia"
  },
  {
    code: "AW",
    name: "Aruba"
  },
  {
    code: "AX",
    name: "Åland"
  },
  {
    code: "AZ",
    name: "Azərbaycan"
  },
  {
    code: "BA",
    name: "Bosna i Hercegovina"
  },
  {
    code: "BB",
    name: "Barbados"
  },
  {
    code: "BD",
    name: "Bangladesh"
  },
  {
    code: "BE",
    name: "België"
  },
  {
    code: "BF",
    name: "Burkina Faso"
  },
  {
    code: "BG",
    name: "България"
  },
  {
    code: "BH",
    name: "‏البحرين"
  },
  {
    code: "BI",
    name: "Burundi"
  },
  {
    code: "BJ",
    name: "Bénin"
  },
  {
    code: "BL",
    name: "Saint-Barthélemy"
  },
  {
    code: "BM",
    name: "Bermuda"
  },
  {
    code: "BN",
    name: "Negara Brunei Darussalam"
  },
  {
    code: "BO",
    name: "Bolivia"
  },
  {
    code: "BQ",
    name: "Bonaire"
  },
  {
    code: "BR",
    name: "Brasil"
  },
  {
    code: "BS",
    name: "Bahamas"
  },
  {
    code: "BT",
    name: "ʼbrug-yul"
  },
  {
    code: "BV",
    name: "Bouvetøya"
  },
  {
    code: "BW",
    name: "Botswana"
  },
  {
    code: "BY",
    name: "Белару́сь"
  },
  {
    code: "BZ",
    name: "Belize"
  },
  {
    code: "CA",
    name: "Canada"
  },
  {
    code: "CC",
    name: "Cocos (Keeling) Islands"
  },
  {
    code: "CD",
    name: "République démocratique du Congo"
  },
  {
    code: "CF",
    name: "Ködörösêse tî Bêafrîka"
  },
  {
    code: "CG",
    name: "République du Congo"
  },
  {
    code: "CH",
    name: "Schweiz"
  },
  {
    code: "CI",
    name: "Côte d'Ivoire"
  },
  {
    code: "CK",
    name: "Cook Islands"
  },
  {
    code: "CL",
    name: "Chile"
  },
  {
    code: "CM",
    name: "Cameroon"
  },
  {
    code: "CN",
    name: "中国"
  },
  {
    code: "CO",
    name: "Colombia"
  },
  {
    code: "CR",
    name: "Costa Rica"
  },
  {
    code: "CU",
    name: "Cuba"
  },
  {
    code: "CV",
    name: "Cabo Verde"
  },
  {
    code: "CW",
    name: "Curaçao"
  },
  {
    code: "CX",
    name: "Christmas Island"
  },
  {
    code: "CY",
    name: "Κύπρος"
  },
  {
    code: "CZ",
    name: "Česká republika"
  },
  {
    code: "DE",
    name: "Deutschland"
  },
  {
    code: "DJ",
    name: "Djibouti"
  },
  {
    code: "DK",
    name: "Danmark"
  },
  {
    code: "DM",
    name: "Dominica"
  },
  {
    code: "DO",
    name: "República Dominicana"
  },
  {
    code: "DZ",
    name: "الجزائر"
  },
  {
    code: "EC",
    name: "Ecuador"
  },
  {
    code: "EE",
    name: "Eesti"
  },
  {
    code: "EG",
    name: "مصر‎"
  },
  {
    code: "EH",
    name: "الصحراء الغربية"
  },
  {
    code: "ER",
    name: "ኤርትራ"
  },
  {
    code: "ES",
    name: "España"
  },
  {
    code: "ET",
    name: "ኢትዮጵያ"
  },
  {
    code: "FI",
    name: "Suomi"
  },
  {
    code: "FJ",
    name: "Fiji"
  },
  {
    code: "FK",
    name: "Falkland Islands"
  },
  {
    code: "FM",
    name: "Micronesia"
  },
  {
    code: "FO",
    name: "Føroyar"
  },
  {
    code: "FR",
    name: "France"
  },
  {
    code: "GA",
    name: "Gabon"
  },
  {
    code: "GD",
    name: "Grenada"
  },
  {
    code: "GE",
    name: "საქართველო"
  },
  {
    code: "GF",
    name: "Guyane française"
  },
  {
    code: "GG",
    name: "Guernsey"
  },
  {
    code: "GH",
    name: "Ghana"
  },
  {
    code: "GI",
    name: "Gibraltar"
  },
  {
    code: "GL",
    name: "Kalaallit Nunaat"
  },
  {
    code: "GM",
    name: "Gambia"
  },
  {
    code: "GN",
    name: "Guinée"
  },
  {
    code: "GP",
    name: "Guadeloupe"
  },
  {
    code: "GQ",
    name: "Guinea Ecuatorial"
  },
  {
    code: "GR",
    name: "Ελλάδα"
  },
  {
    code: "GS",
    name: "South Georgia"
  },
  {
    code: "GT",
    name: "Guatemala"
  },
  {
    code: "GU",
    name: "Guam"
  },
  {
    code: "GW",
    name: "Guiné-Bissau"
  },
  {
    code: "GY",
    name: "Guyana"
  },
  {
    code: "HK",
    name: "香港"
  },
  {
    code: "HM",
    name: "Heard Island and McDonald Islands"
  },
  {
    code: "HN",
    name: "Honduras"
  },
  {
    code: "HR",
    name: "Hrvatska"
  },
  {
    code: "HT",
    name: "Haïti"
  },
  {
    code: "HU",
    name: "Magyarország"
  },
  {
    code: "ID",
    name: "Indonesia"
  },
  {
    code: "IE",
    name: "Ireland"
  },
  {
    code: "IL",
    name: "יִשְׂרָאֵל"
  },
  {
    code: "IM",
    name: "Isle of Man"
  },
  {
    code: "IN",
    name: "भारत"
  },
  {
    code: "IO",
    name: "British Indian Ocean Territory"
  },
  {
    code: "IQ",
    name: "العراق"
  },
  {
    code: "IR",
    name: "ایران"
  },
  {
    code: "IS",
    name: "Ísland"
  },
  {
    code: "IT",
    name: "Italia"
  },
  {
    code: "JE",
    name: "Jersey"
  },
  {
    code: "JM",
    name: "Jamaica"
  },
  {
    code: "JO",
    name: "الأردن"
  },
  {
    code: "JP",
    name: "日本"
  },
  {
    code: "KE",
    name: "Kenya"
  },
  {
    code: "KG",
    name: "Кыргызстан"
  },
  {
    code: "KH",
    name: "Kâmpŭchéa"
  },
  {
    code: "KI",
    name: "Kiribati"
  },
  {
    code: "KM",
    name: "Komori"
  },
  {
    code: "KN",
    name: "Saint Kitts and Nevis"
  },
  {
    code: "KP",
    name: "북한"
  },
  {
    code: "KR",
    name: "대한민국"
  },
  {
    code: "KW",
    name: "الكويت"
  },
  {
    code: "KY",
    name: "Cayman Islands"
  },
  {
    code: "KZ",
    name: "Қазақстан"
  },
  {
    code: "LA",
    name: "ສປປລາວ"
  },
  {
    code: "LB",
    name: "لبنان"
  },
  {
    code: "LC",
    name: "Saint Lucia"
  },
  {
    code: "LI",
    name: "Liechtenstein"
  },
  {
    code: "LK",
    name: "śrī laṃkāva"
  },
  {
    code: "LR",
    name: "Liberia"
  },
  {
    code: "LS",
    name: "Lesotho"
  },
  {
    code: "LT",
    name: "Lietuva"
  },
  {
    code: "LU",
    name: "Luxembourg"
  },
  {
    code: "LV",
    name: "Latvija"
  },
  {
    code: "LY",
    name: "‏ليبيا"
  },
  {
    code: "MA",
    name: "المغرب"
  },
  {
    code: "MC",
    name: "Monaco"
  },
  {
    code: "MD",
    name: "Moldova"
  },
  {
    code: "ME",
    name: "Црна Гора"
  },
  {
    code: "MF",
    name: "Saint-Martin"
  },
  {
    code: "MG",
    name: "Madagasikara"
  },
  {
    code: "MH",
    name: "M̧ajeļ"
  },
  {
    code: "MK",
    name: "Македонија"
  },
  {
    code: "ML",
    name: "Mali"
  },
  {
    code: "MM",
    name: "Myanma"
  },
  {
    code: "MN",
    name: "Монгол улс"
  },
  {
    code: "MO",
    name: "澳門"
  },
  {
    code: "MP",
    name: "Northern Mariana Islands"
  },
  {
    code: "MQ",
    name: "Martinique"
  },
  {
    code: "MR",
    name: "موريتانيا"
  },
  {
    code: "MS",
    name: "Montserrat"
  },
  {
    code: "MT",
    name: "Malta"
  },
  {
    code: "MU",
    name: "Maurice"
  },
  {
    code: "MV",
    name: "Maldives"
  },
  {
    code: "MW",
    name: "Malawi"
  },
  {
    code: "MX",
    name: "México"
  },
  {
    code: "MY",
    name: "Malaysia"
  },
  {
    code: "MZ",
    name: "Moçambique"
  },
  {
    code: "NA",
    name: "Namibia"
  },
  {
    code: "NC",
    name: "Nouvelle-Calédonie"
  },
  {
    code: "NE",
    name: "Niger"
  },
  {
    code: "NF",
    name: "Norfolk Island"
  },
  {
    code: "NG",
    name: "Nigeria"
  },
  {
    code: "NI",
    name: "Nicaragua"
  },
  {
    code: "NL",
    name: "Nederland"
  },
  {
    code: "NO",
    name: "Norge"
  },
  {
    code: "NP",
    name: "नपल"
  },
  {
    code: "NR",
    name: "Nauru"
  },
  {
    code: "NU",
    name: "Niuē"
  },
  {
    code: "NZ",
    name: "New Zealand"
  },
  {
    code: "OM",
    name: "عمان"
  },
  {
    code: "PA",
    name: "Panamá"
  },
  {
    code: "PE",
    name: "Perú"
  },
  {
    code: "PF",
    name: "Polynésie française"
  },
  {
    code: "PG",
    name: "Papua Niugini"
  },
  {
    code: "PH",
    name: "Pilipinas"
  },
  {
    code: "PK",
    name: "Pakistan"
  },
  {
    code: "PL",
    name: "Polska"
  },
  {
    code: "PM",
    name: "Saint-Pierre-et-Miquelon"
  },
  {
    code: "PN",
    name: "Pitcairn Islands"
  },
  {
    code: "PR",
    name: "Puerto Rico"
  },
  {
    code: "PS",
    name: "فلسطين"
  },
  {
    code: "PT",
    name: "Portugal"
  },
  {
    code: "PW",
    name: "Palau"
  },
  {
    code: "PY",
    name: "Paraguay"
  },
  {
    code: "QA",
    name: "قطر"
  },
  {
    code: "RE",
    name: "La Réunion"
  },
  {
    code: "RO",
    name: "România"
  },
  {
    code: "RS",
    name: "Србија"
  },
  {
    code: "RU",
    name: "Россия"
  },
  {
    code: "RW",
    name: "Rwanda"
  },
  {
    code: "SA",
    name: "العربية السعودية"
  },
  {
    code: "SB",
    name: "Solomon Islands"
  },
  {
    code: "SC",
    name: "Seychelles"
  },
  {
    code: "SD",
    name: "السودان"
  },
  {
    code: "SE",
    name: "Sverige"
  },
  {
    code: "SG",
    name: "Singapore"
  },
  {
    code: "SH",
    name: "Saint Helena"
  },
  {
    code: "SI",
    name: "Slovenija"
  },
  {
    code: "SJ",
    name: "Svalbard og Jan Mayen"
  },
  {
    code: "SK",
    name: "Slovensko"
  },
  {
    code: "SL",
    name: "Sierra Leone"
  },
  {
    code: "SM",
    name: "San Marino"
  },
  {
    code: "SN",
    name: "Sénégal"
  },
  {
    code: "SO",
    name: "Soomaaliya"
  },
  {
    code: "SR",
    name: "Suriname"
  },
  {
    code: "SS",
    name: "South Sudan"
  },
  {
    code: "ST",
    name: "São Tomé e Príncipe"
  },
  {
    code: "SV",
    name: "El Salvador"
  },
  {
    code: "SX",
    name: "Sint Maarten"
  },
  {
    code: "SY",
    name: "سوريا"
  },
  {
    code: "SZ",
    name: "Swaziland"
  },
  {
    code: "TC",
    name: "Turks and Caicos Islands"
  },
  {
    code: "TD",
    name: "Tchad"
  },
  {
    code: "TF",
    name: "Territoire des Terres australes et antarctiques fr"
  },
  {
    code: "TG",
    name: "Togo"
  },
  {
    code: "TH",
    name: "ประเทศไทย"
  },
  {
    code: "TJ",
    name: "Тоҷикистон"
  },
  {
    code: "TK",
    name: "Tokelau"
  },
  {
    code: "TL",
    name: "Timor-Leste"
  },
  {
    code: "TM",
    name: "Türkmenistan"
  },
  {
    code: "TN",
    name: "تونس"
  },
  {
    code: "TO",
    name: "Tonga"
  },
  {
    code: "TR",
    name: "Türkiye"
  },
  {
    code: "TT",
    name: "Trinidad and Tobago"
  },
  {
    code: "TV",
    name: "Tuvalu"
  },
  {
    code: "TW",
    name: "臺灣"
  },
  {
    code: "TZ",
    name: "Tanzania"
  },
  {
    code: "UA",
    name: "Україна"
  },
  {
    code: "UG",
    name: "Uganda"
  },
  {
    code: "GB",
    name: "United Kingdom"
  },
  {
    code: "US",
    name: "United States"
  },
  {
    code: "UM",
    name: "United States Minor Outlying Islands"
  },
  {
    code: "VI",
    name: "United States Virgin Islands"
  },
  {
    code: "UY",
    name: "Uruguay"
  },
  {
    code: "UZ",
    name: "O‘zbekiston"
  },
  {
    code: "VA",
    name: "Vaticano"
  },
  {
    code: "VC",
    name: "Saint Vincent and the Grenadines"
  },
  {
    code: "VE",
    name: "Venezuela"
  },
  {
    code: "VG",
    name: "British Virgin Islands"
  },
  {
    code: "VN",
    name: "Việt Nam"
  },
  {
    code: "VU",
    name: "Vanuatu"
  },
  {
    code: "WF",
    name: "Wallis et Futuna"
  },
  {
    code: "WS",
    name: "Samoa"
  },
  {
    code: "XK",
    name: "Republika e Kosovës"
  },
  {
    code: "YE",
    name: "اليَمَن"
  },
  {
    code: "YT",
    name: "Mayotte"
  },
  {
    code: "ZA",
    name: "South Africa"
  },
  {
    code: "ZM",
    name: "Zambia"
  },
  {
    code: "ZW",
    name: "Zimbabwe"
  }
];
